module.exports = __webpack_public_path__ + "static/media/p_20_3.b6cb1f06.png";